const menuConfig = {
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [
      {
        title: "Dashboard",
        root: true,
        icon: "fas fa-tachometer-alt",
        page: "dashboard",
      },
      {
        title: "Clientes",
        root: true,
        icon: "fas fa-user",
        page: "cliente",
      },
      {
        title: "Motoristas",
        root: true,
        icon: "fas fa-user-tie",
        page: "motorista",
      },
      {
        title: "Veículos",
        root: true,
        icon: "fas fa-car-side",
        page: "veiculo",
      },
      {
        title: "Agenda de veículos",
        root: true,
        icon: "fas fa-calendar",
        page: "agenda-veiculo",
      },
      {
        title: "Viagens",
        root: true,
        icon: "fas fa-route",
        page: "viagem",
      },
      {
        title: "Pagamentos",
        root: true,
        icon: "fas fa-money-bill",
        page: "pagamento",
      },
      {
        title: "Tarifas e taxas",
        root: true,
        icon: "fas fa-dollar-sign",
        submenu: [
          {
            title: "Tarifas",
            page: "tarifa",
          },
          {
            title: "Cancelamentos",
            page: "cancelamento",
          },
          {
            title: "Comissão interna",
            page: "comissao",
          },
        ],
      },
      {
        title: "Relatórios",
        root: true,
        icon: "fas fa-chart-pie",
        submenu: [
          {
            title: "Financeiro",
            page: "relatorio/financeiro",
          },
          {
            title: "Viagens",
            page: "relatorio/viagens",
          },
        ],
      },
      {
        title: "Acessos",
        root: true,
        icon: "fas fa-users",
        submenu: [
          {
            title: "Usuários",
            page: "admin",
          },
          {
            title: "Grupos de permissões",
            page: "grupo",
          },
        ],
      },
    ],
  },
};

export default menuConfig;
